import {share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {getMessageFromException} from '../utilities/Util';
import {NotificationService} from './NotificationService';
import {FederalPovertyLevel, FederalPovertyLevelClient, SimpleDecimalResult} from './api.client';
import {Observable} from 'rxjs';

// 003-retire-ngrx (US2): the fpl slice was deleted outright — it was
// write-only state (its selectors file was empty; nothing ever read it).
// Callers already consume these methods' returned observables directly.
@Injectable()
export class FederalPovertyLevelService {

  constructor(private _federalPovertyLevelApiService: FederalPovertyLevelClient,
              private _notificationService: NotificationService) {
  }

  addFederalPovertyLevel(federalPovertyLevel: FederalPovertyLevel): Observable<FederalPovertyLevel> {
    const request = this._federalPovertyLevelApiService.addFederalPovertyLevel(federalPovertyLevel).pipe(share());
    request.subscribe({ next: () => {
      this._notificationService.showSuccess('Keeping Current Application Successfully Created!');
    }, error: (err) => {
        this._notificationService.showError(getMessageFromException(err));
    }, complete: () => {

    }});
    return request;
  }

  updateFederalPovertyLevel(federalPovertyLevel: FederalPovertyLevel): Observable<FederalPovertyLevel> {
    const request = this._federalPovertyLevelApiService.updateFederalPovertyLevel(federalPovertyLevel).pipe(share());
    request.subscribe({ next: () => {
      this._notificationService.showSuccess('Keeping Current Application Succesfully Updated!');
    }, error: () => {
      this._notificationService.showError('There was a problem updating this Keeping Current Application.');
    }, complete: () => {

    }});
    return request;
  }

  validateFederalPovertyLevel(houseHoldSize: number, houseHoldIncome: number): Observable<SimpleDecimalResult> {
    const request = this._federalPovertyLevelApiService.calculateFederalPovertyLevel(houseHoldSize, houseHoldIncome).pipe(share());
    request.subscribe({ next: () => {
    }, error: () => {
      this._notificationService.showError('There was a problem retrieving the Poverty Level of the selected client.');
    }, complete: () => {

    }});
    return request;
  }
}
